import { createSelector } from 'reselect';

const loadingSelector = state => state.get('loading');

export const countSelector = createSelector(
  loadingSelector,
  state => state.get('count')
);
